// Copyright (c) 2023 Deere & Company

import React from 'react';
import {getDefaultState as getCustomerDefaultState} from '@deere/cps-it.warranty-model-factory/lib/customer';
import {getStore} from '../../../store-factory';

const getTheme = () =>

    getStore().getState().user.details.settings.theme.preferredTheme.key === '02' ? 'agriculture-turf' : 'construction-forestry';

const getLocale = () => {

    const rawLocale = getStore().getState().user.details.getCkcValue();

    return rawLocale.replace(/_/, '-');

};

export const getSearchConfiguration = (customer = getCustomerDefaultState(), route) => ({

    configuration: {
        businessActivities: {
            canAddEdit: true,
            canMerge: true
        },
        customerIds: {
            contactId: '',
            entityId: route === 'EDIT_CUSTOMER' ? customer.ckcId : ''
        },
        features: {
            search: {
                addToContextButton: {
                    show: true
                },
                preFilledFacets: {

                    city: customer.physicalAddress.city,
                    country: customer.physicalAddress.country,
                    firstName: customer.individual.first,
                    postalCode: customer.physicalAddress.postalCode,
                    query: {
                        constraint: 'CONTAINS',
                        searchString: customer.individual.last ? customer.individual.last : customer.business.primaryName
                    },
                    state: customer.physicalAddress.state

                }
            }
        },
        locale: getLocale(),
        parentAppName: 'Warranty',
        routing: {
            view: route
        },
        theme: getTheme()
    },
    type: 'csc-configuration'
});

export const buildCkc2SearchFrame = () => {

    const csc2Url = getStore().getState().appConfig.csc.csc2Url;

    return (
        <iframe
            className='warranty-ckc-iframe'
            src={csc2Url}
        />
    );

};

export const sendMessageToIframe = (customer, route) => {

    const iframeEl = document.querySelector('.warranty-ckc-iframe');

    const configString = JSON.stringify(getSearchConfiguration(customer, route));

    iframeEl.contentWindow.postMessage(configString, getStore().getState().appConfig.csc.csc2Url);

};



// WEBPACK FOOTER //
// ./src/product/shared/services/customer-search-2.js